var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "bi:emoji-laughing",
    clipPath: "url(#clip0_503_702)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 18.75C7.67936 18.75 5.45376 17.8281 3.81282 16.1872C2.17187 14.5462 1.25 12.3206 1.25 10C1.25 7.67936 2.17187 5.45376 3.81282 3.81282C5.45376 2.17187 7.67936 1.25 10 1.25C12.3206 1.25 14.5462 2.17187 16.1872 3.81282C17.8281 5.45376 18.75 7.67936 18.75 10C18.75 12.3206 17.8281 14.5462 16.1872 16.1872C14.5462 17.8281 12.3206 18.75 10 18.75ZM10 20C12.6522 20 15.1957 18.9464 17.0711 17.0711C18.9464 15.1957 20 12.6522 20 10C20 7.34784 18.9464 4.8043 17.0711 2.92893C15.1957 1.05357 12.6522 0 10 0C7.34784 0 4.8043 1.05357 2.92893 2.92893C1.05357 4.8043 0 7.34784 0 10C0 12.6522 1.05357 15.1957 2.92893 17.0711C4.8043 18.9464 7.34784 20 10 20Z",
    fill: "url(#paint0_linear_503_702)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.4136 11.875C15.5234 12.065 15.5811 12.2806 15.5811 12.5C15.5811 12.7194 15.5234 12.935 15.4136 13.125C14.8652 14.0755 14.0761 14.8647 13.1257 15.4133C12.1753 15.9619 11.0972 16.2504 9.99989 16.25C8.90276 16.2502 7.82492 15.9615 6.87479 15.413C5.92465 14.8644 5.13574 14.0753 4.58739 13.125C4.47773 12.9351 4.41998 12.7196 4.41992 12.5003C4.41987 12.281 4.47751 12.0655 4.58707 11.8756C4.69663 11.6856 4.85424 11.5278 5.04409 11.4179C5.23394 11.3081 5.44933 11.2502 5.66864 11.25H14.3311C14.5506 11.25 14.7661 11.3078 14.9561 11.4175C15.1461 11.5272 15.3039 11.685 15.4136 11.875ZM8.74989 8.125C8.74989 9.16 8.18989 8.125 7.49989 8.125C6.80989 8.125 6.24989 9.16 6.24989 8.125C6.24989 7.09 6.80989 6.25 7.49989 6.25C8.18989 6.25 8.74989 7.09 8.74989 8.125ZM13.7499 8.125C13.7499 9.16 13.1899 8.125 12.4999 8.125C11.8099 8.125 11.2499 9.16 11.2499 8.125C11.2499 7.09 11.8099 6.25 12.4999 6.25C13.1899 6.25 13.7499 7.09 13.7499 8.125Z",
    fill: "url(#paint1_linear_503_702)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_503_702",
    x1: 0,
    y1: 10,
    x2: 20,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_503_702",
    x1: 4.41992,
    y1: 11.25,
    x2: 15.5811,
    y2: 11.25,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E93FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3153C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_503_702"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/emoji.7bffb2301cd44c53048a30f759b3440b.svg";
export { ForwardRef as ReactComponent };